export class modeloCRM {
    mensaje: string = "";
    //Id asignado
    clienteId: number = 0;
    asunto?: string = "Coche Seguro (Error)";
}
export class notificacion {
    url: string = "";
    aseguradoraID: number = 0;
    cotizacionID?: string = "";
    emisionID?: string = "";
    noPoliza?: string = "";
    msgError?: string = "";
    clienteID?: number = 0;
    asunto?: string = "Coche Seguro (Error)";
    vehiculo?: string = "";
}
export class CRM {
    //worksite
    v1: number = 3;
    //asunto
    v2: string = "";
    //mensaje
    v3: string = "";
    //Id asignado
    v4: entidad = new entidad();
    //Id entidadTipo
    entidadTipo?: number = 0;
    //Id entidad
    entidad?: string = "";
    crmStatus?: number = 4;
}
export class entidad {
    //value
    c1: number = 0;
}